import { render, staticRenderFns } from "./SFootprint.vue?vue&type=template&id=65b820f5&scoped=true"
import script from "./sFootprint.ts?vue&type=script&lang=ts&external"
export * from "./sFootprint.ts?vue&type=script&lang=ts&external"
import style0 from "./SFootprint.vue?vue&type=style&index=0&id=65b820f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b820f5",
  null
  
)

export default component.exports